import { render, staticRenderFns } from "./AttendanceCorrectionsDetail.vue?vue&type=template&id=7b1ba84a"
import script from "./AttendanceCorrectionsDetail.vue?vue&type=script&lang=js"
export * from "./AttendanceCorrectionsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports